import { Button } from "react-bootstrap";
import { useVrboCreatePropertyMutation } from "../../services/bClientApi";
import JSONData from "../JSONData/JSONData";
import useVrboAction from "./useVrboAction";
import { VrboIntegrationRecord } from "./useVrboIntegrationRecord";

export default function VrboNotConnected(
    props: {
        propertyId: string
        record: VrboIntegrationRecord
    }
) {
    const { propertyId, record } = props
    const {
        vrboPropertyData,
        setVrboPropertyData,
        vrboQueryErrorData,
        setVrboQueryErrorData,
        isQueryingVRBO,
        handleQueryVRBOProperty,
        createIntegrationData,
        isCreatingIntegration,
        createIntegrationError,
    } = record

    const [createProperty] = useVrboCreatePropertyMutation()
    const createPropertyAction = useVrboAction(
        () => createProperty(propertyId).unwrap(),
        { errorLabel: 'creating VRBO property', enabled: !!propertyId },
    )

    return (
        <div>
            <p>No integration found for this property.</p>

            <div className="d-flex gap-2 mb-3">
                <Button onClick={handleQueryVRBOProperty} disabled={isQueryingVRBO}>
                    {isQueryingVRBO ? 'Querying VRBO...' : 'Query VRBO Property'}
                </Button>
                {!vrboPropertyData && (
                    <Button variant="success" onClick={createPropertyAction.run} disabled={createPropertyAction.isLoading}>
                        {createPropertyAction.isLoading ? 'Creating...' : 'Create Property'}
                    </Button>
                )}
            </div>

            {createPropertyAction.status !== 'idle' && (
                <div className="mb-3">
                    <JSONData data={createPropertyAction.result} title="Create Property Response" onClose={createPropertyAction.clear} />
                </div>
            )}

            {vrboQueryErrorData && (
                <div className="mb-3">
                    <JSONData data={vrboQueryErrorData} title="Error querying VRBO property" onClose={() => setVrboQueryErrorData(null)} />
                </div>
            )}

            {vrboPropertyData && (
                <div>
                    <JSONData data={vrboPropertyData} title="VRBO Property Data" onClose={() => setVrboPropertyData(null)} />
                    <Button className="mt-2" onClick={createIntegrationData} disabled={isCreatingIntegration}>
                        {isCreatingIntegration ? 'Creating Integration...' : 'Create Integration'}
                    </Button>
                    {createIntegrationError && (
                        <JSONData data={createIntegrationError} title="Error creating integration" />
                    )}
                </div>
            )}
        </div>
    )
}
